<template lang="html">
    <div class="newSkill" v-if="editOpen">
        <form class="form3" @submit.prevent="saveSkill">
            <div class="formGroup">
                <label>Skill title:</label>
                <input
                    type="text"
                    maxlength="255"
                    v-model="form.discipline"
                    :class="{ 'is-invalid': form.errors.has('discipline') }"
                />
                <!--<has-error class="info error" :form="form" field="discipline"/>-->
            </div>

            <div class="formGroup">
                <label>Score out of 10:</label>
                <input
                    type="tel"
                    maxlength="2"
                    v-model="form.score"
                    :class="{ 'is-invalid': form.errors.has('score') }"
                />
                <!--<has-error  class="info error" :form="form" field="score"/>-->
            </div>

            <div class="formGroup">
                <label>Notes:</label>

                <textarea-autosize v-model="form.description" :min-height="30" />
            </div>

            <div class="formGroup">
                <label>Related Lessons:</label>

                <ul>
                    <skill-lesson-record
                        v-for="lesson in lessons"
                        :relatedLesson="form.lesson_id"
                        :key="lesson.id"
                        :lesson="lesson"
                        @AddRelatedLesson="AddRelatedLessonRecord"
                    />
                </ul>
                <!--<div class="select">
            <select v-model="form.lesson_id" :class="{ 'is-invalid': form.errors.has('lesson_id') }">
              <option value="">Add a lesson</option>
              <option :value="lesson.id" v-for="lesson in lessons" :key="lesson.id">
                  {{$date(lesson.date).format('D MMM YYYY')}}
              </option>
            </select>
            <plus-icon class="icon" style="pointer-events:none"/>
            <button @click.prevent="removeLesson" v-if="form.lesson_id" class="button red removeRelatedLesson" type="button" name="button"><img style="margin-left:7px;" src="@/assets/minus.svg"/></button>
          </div>-->
            </div>

            <button :disabled="form.busy" class="button" type="submit" name="button">
                {{ form.busy ? "Please wait..." : "Save" }}
            </button>
        </form>
    </div>
</template>

<script>
import { Form } from "vform";
import SkillLessonRecord from "@/views/Pro/Players/Player/partials/skill-lesson-record";
export default {
    name: "add-edit-skill",
    components: { SkillLessonRecord },
    props: {
        editOpen: {
            type: Boolean,
            default: false,
            required: false,
        },
        type: {
            type: String,
            default: "new",
            required: false,
        },
        skill: {
            required: false,
        },
    },
    mounted() {
        this.getPlayerLessons();
        if (this.skill) {
            console.log(this.skill);
            this.form.fill(this.skill);

            if (!this.skill.lesson_id) {
                this.form.lesson_id = "";
            }
        }
    },
    computed: {
        player() {
            return this.$store.state.activePlayer;
        },
    },
    data() {
        return {
            lessons: [],
            form: new Form({
                discipline: "",
                description: "",
                score: "",
                lesson_id: "",
                user_id: "",
            }),
        };
    },
    methods: {
        AddRelatedLessonRecord($id) {
            this.form.lesson_id = $id;
        },
        closeForm() {
            this.$emit("addEditSkillClosed", false);
        },
        saveSkill() {
            this.form.user_id = this.$route.params.id;

            if (this.type == "edit") {
                this.form.put("/skill/" + this.skill.id).then((response) => {
                    this.closeForm();
                    this.$emit("skillAdded", response.data);
                    this.$notify({
                        text: "Skill updated",
                    });
                });
            } else {
                // Its not an update, its a new one
                this.form.post("/skill").then((response) => {
                    this.closeForm();
                    this.form.discipline = "";
                    this.form.description = "";
                    this.form.score = "";
                    this.form.lesson_id = "";
                    this.$emit("skillAdded", response.data);
                    this.$notify({
                        text: "Skill added",
                    });
                });
            }
        },
        removeLesson() {
            this.form.lesson_id = "";
        },
        getPlayerLessons() {
            window.axios.get("player/" + this.$route.params.id + "/lessons").then((response) => {
                this.lessons = response.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.newSkill {
    background: $green_0;
    border-radius: $radius;
    margin-top: 20px;
    padding: 20px;
    margin-bottom: 20px;
    padding-top: 30px;
    padding-bottom: 30px;

    label {
        color: white !important;
    }

    .select {
        height: 49px;
        .icon {
            position: absolute;
            right: 15px;
            top: 14px;
            width: 18px;
        }
        button {
            height: 49px;
        }

        .removeRelatedLesson {
            position: absolute;
            right: 0px;
            top: 0px;
            width: 58px;
            height: 49px !important;
            padding: 0px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            &:before {
                background: #444745;
                content: "";
                position: absolute;
                height: 100%;
                width: 12px;
                left: 0px;
                top: 0px;
                border-top-right-radius: 12px;
                border-bottom-right-radius: 12px;
            }
            .icon {
                margin-left: 12px;
                margin-top: 2px;
            }
        }

        select {
            background: #444745;
            color: white;
            margin: 0px;
            height: 49px;
        }
    }
}
</style>
